import React, {useState, useRef, useEffect} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import CitySelect from '../../components/CitySelect';
import { ALL_CITIES } from '../../components/Cities';
import { ALL_UNIVERSITIES } from '../../components/Universities';
import UniversitySelect from '../../components/UniversitySelect';
import {Form} from "react-bootstrap";
import {PhoneInput} from 'react-international-phone';
import 'react-international-phone/style.css';
import {PhoneNumberUtil} from 'google-libphonenumber';
import {Button, useToaster} from "@gravity-ui/uikit";

import UserCard from "../../components/userCard/UserCard";
import {load_user} from "../../actions/auth";
import {Pencil} from "@gravity-ui/icons";
import {AUTH_LOAD_CURRENT_USER_ENDPOINT, getAcceptAuthConfig} from "../../api/api";


const VALID_POSITIONS = ['Студент', 'Школьник', 'Прочее'];

const UserFormUpdate = ({user, load_user}) => {
    const {add: addToast} = useToaster();
    const [formData, setFormData] = useState({
        last_name: "",
        first_name: "",
        middle_name: "",
        contact: "",
        phone_number: "",
        birth_date: "",
        workplace: "",
        address: ""
    });

    const [formErrors, setFormErrors] = useState({
        last_name: '',
        first_name: '',
        address: '',
        position: '',
        workplace: '',
        contact: '',
        phone_number: '',
        birth_date: ''
    });

    const [submitting, setSubmitting] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');
    const [isCustomCity, setIsCustomCity] = useState(false);
    const [isCustomUniversity, setIsCustomUniversity] = useState(false);
    const filePicker = useRef(null);

    useEffect(() => {
        if (user) {
            const role = VALID_POSITIONS.includes(user.position) ? user.position : '';
            setSelectedRole(role);
            const address = user.address || '';
            setIsCustomCity(!!address && !ALL_CITIES.includes(address));
            const workplace = role === 'Студент' ? (user.workplace || '') : '';
            setIsCustomUniversity(!!workplace && !ALL_UNIVERSITIES.includes(workplace));
            setFormData({
                last_name: user.last_name || "",
                first_name: user.first_name || "",
                middle_name: user.middle_name || "",
                contact: user.contact || "",
                phone_number: user.phone_number || "",
                birth_date: user.birth_date || "",
                workplace: role ? (user.workplace || "") : "",
                address: user.address || ""
            });
        }
    }, [user]);

    const phoneUtil = PhoneNumberUtil.getInstance();

    const isPhoneValid = (phone) => {
        try {
            return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
        } catch (error) {
            return false;
        }
    };

    const onSubmit = (e) => {
        e.preventDefault();

        setFormErrors({
            last_name: '',
            first_name: '',
            address: '',
            position: '',
            workplace: '',
            contact: '',
            phone_number: '',
            birth_date: ''
        });

        let hasErrors = false;
        const newErrors = {};

        if (!formData.last_name.trim()) {
            newErrors.last_name = 'Фамилия обязательна';
            hasErrors = true;
        }

        if (!formData.first_name.trim()) {
            newErrors.first_name = 'Имя обязательно';
            hasErrors = true;
        }

        if (!formData.address.trim()) {
            newErrors.address = 'Город обязателен';
            hasErrors = true;
        }

        if (!selectedRole) {
            newErrors.position = 'Выберите вашу роль';
            hasErrors = true;
        } else if (!formData.workplace.trim()) {
            newErrors.workplace = selectedRole === 'Студент' ? 'Выберите ВУЗ из списка' : 'Заполните это поле';
            hasErrors = true;
        }

        if (!formData.contact.trim()) {
            newErrors.contact = 'Укажите контактные данные';
            hasErrors = true;
        }

        if (!formData.phone_number || !isPhoneValid(formData.phone_number)) {
            newErrors.phone_number = 'Укажите корректный номер телефона';
            hasErrors = true;
        }

        if (!formData.birth_date) {
            newErrors.birth_date = 'Укажите дату рождения';
            hasErrors = true;
        }

        if (hasErrors) {
            setFormErrors(newErrors);
            return;
        }
        setSubmitting(true);

        let formattedBirthDate = null;

        if (formData.birth_date && formData.birth_date.toString().trim()) {
            const birthDateStr = formData.birth_date.toString().trim();

            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

            if (dateRegex.test(birthDateStr)) {
                formattedBirthDate = birthDateStr;
            } else {
                const date = new Date(birthDateStr);
                if (!isNaN(date.getTime())) {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    formattedBirthDate = `${year}-${month}-${day}`;
                } else {
                    formattedBirthDate = birthDateStr;
                }
            }
        }

        const formDataToSend = {
            last_name: formData.last_name,
            first_name: formData.first_name,
            middle_name: formData.middle_name,
            contact: formData.contact,
            phone_number: formData.phone_number,
            position: selectedRole,
            workplace: formData.workplace,
            address: formData.address,
        };

        formDataToSend.birth_date = formattedBirthDate;

        axios
            .patch(AUTH_LOAD_CURRENT_USER_ENDPOINT, formDataToSend, getAcceptAuthConfig())
            .then(() => {
                load_user();
                addToast({name: 'save-success', title: 'Профиль сохранён', theme: 'success', autoHiding: 4000});
            })
            .catch(error => {
                let errorMessage = 'Произошла ошибка при сохранении профиля';

                if (error.response?.data?.birth_date) {
                    errorMessage = `Ошибка в поле "Дата рождения": ${error.response.data.birth_date.join(', ')}`;
                } else if (error.response?.data) {
                    const serverErrors = error.response.data;
                    const firstError = Object.values(serverErrors)[0];
                    if (Array.isArray(firstError)) {
                        errorMessage = firstError[0];
                    } else if (typeof firstError === 'string') {
                        errorMessage = firstError;
                    }
                }

                addToast({name: 'save-error', title: 'Ошибка', content: errorMessage, theme: 'danger'});
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));

        // Очищаем ошибку при изменении поля
        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const onChangePhone = (e) => {
        setFormData((prevData) => ({
            ...prevData,
            phone_number: e
        }));
        if (formErrors.phone_number) {
            setFormErrors(prev => ({ ...prev, phone_number: '' }));
        }
    }

    const handleSelectChange = (fieldName, value) => {
        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));

        if (formErrors[fieldName]) {
            setFormErrors(prev => ({
                ...prev,
                [fieldName]: ''
            }));
        }
    };

    const onChangeAvatar = async (e) => {
        const formData = new FormData();
        formData.append('avatar', e.target.files[0]);

        axios
            .patch(AUTH_LOAD_CURRENT_USER_ENDPOINT, formData, getAcceptAuthConfig())
            .then(() => {
                load_user();
            })
            .catch(() => {
                addToast({name: 'avatar-error', title: 'Ошибка', content: 'Ошибка при обновлении аватара', theme: 'danger'});
            })
    };

const onPick = () => {
        filePicker.current.click();
    };

    const handleRoleChange = (role) => {
        setSelectedRole(role);
        setIsCustomUniversity(false);
        setFormData(prev => ({ ...prev, workplace: '' }));
        setFormErrors(prev => ({ ...prev, position: '', workplace: '' }));
    };

    const getUniversitySelectStyles = (hasError) => ({
        control: (base, state) => ({
            ...base,
            borderColor: hasError ? '#dc3545' : base.borderColor,
            '&:hover': {
                borderColor: hasError ? '#dc3545' : base.borderColor
            }
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10001
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 10001
        }),
        container: (provided) => ({
            ...provided,
            zIndex: 10001,
            position: 'relative'
        })
    });

    const getCitySelectStyles = (hasError) => ({
        control: (base, state) => ({
            ...base,
            borderColor: hasError ? '#dc3545' : base.borderColor,
            '&:hover': {
                borderColor: hasError ? '#dc3545' : base.borderColor
            }
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10000
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 10000
        }),
        container: (provided) => ({
            ...provided,
            zIndex: 10000,
            position: 'relative'
        })
    });

    return (
        <>
            <h3 className="mb-2">Редактирование профиля</h3>
            <hr className="clearfix w-100 pb-0"/>
            <div className="row d-flex flex-column-reverse flex-lg-row">
                <div className="col-lg-9 mt-lg-0 mt-3">
                    <Form onSubmit={onSubmit} noValidate>

                        <Form.Group controlId="formLastname" className="mb-3">
                            <Form.Label className="required">Фамилия</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="last_name"
                                value={formData.last_name}
                                onChange={onChange}
                                isInvalid={!!formErrors.last_name}
                            />
                            {formErrors.last_name && (
                                <div className="invalid-feedback d-block">{formErrors.last_name}</div>
                            )}
                        </Form.Group>

                        <Form.Group controlId="formFirstname" className="mb-3">
                            <Form.Label className="required">Имя</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="first_name"
                                value={formData.first_name}
                                onChange={onChange}
                                isInvalid={!!formErrors.first_name}
                            />
                            {formErrors.first_name && (
                                <div className="invalid-feedback d-block">{formErrors.first_name}</div>
                            )}
                        </Form.Group>

                        <Form.Group controlId="formMiddlename" className="mb-3">
                            <Form.Label>Отчество</Form.Label>
                            <Form.Control
                                type="text"
                                name="middle_name"
                                value={formData.middle_name}
                                onChange={onChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="required">Кто вы?</Form.Label>
                            <div className="d-flex gap-4 mt-1">
                                {VALID_POSITIONS.map(role => (
                                    <Form.Check
                                        key={role}
                                        type="radio"
                                        id={`role-${role}`}
                                        label={role}
                                        name="role"
                                        checked={selectedRole === role}
                                        onChange={() => handleRoleChange(role)}
                                    />
                                ))}
                            </div>
                            {formErrors.position && (
                                <div className="invalid-feedback d-block">{formErrors.position}</div>
                            )}
                        </Form.Group>

                        {selectedRole && (
                            <Form.Group controlId="formWorkplace" className="mb-3">
                                <Form.Label className="required">
                                    {selectedRole === 'Студент' ? 'ВУЗ' : selectedRole === 'Школьник' ? 'Школа' : 'Место работы / должность'}
                                </Form.Label>
                                {selectedRole === 'Студент' ? (
                                    <>
                                        <div className="form-check mb-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isCustomUniversityCheckbox"
                                                checked={isCustomUniversity}
                                                onChange={(e) => {
                                                    setIsCustomUniversity(e.target.checked);
                                                    handleSelectChange('workplace', '');
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="isCustomUniversityCheckbox">
                                                Моего ВУЗа нет в списке
                                            </label>
                                        </div>
                                        {isCustomUniversity ? (
                                            <Form.Control
                                                type="text"
                                                name="workplace"
                                                value={formData.workplace}
                                                onChange={onChange}
                                                placeholder="Введите название ВУЗа"
                                                isInvalid={!!formErrors.workplace}
                                            />
                                        ) : (
                                            <UniversitySelect
                                                value={formData.workplace}
                                                onChange={(value) => handleSelectChange('workplace', value)}
                                                placeholder="Начните вводить название ВУЗа..."
                                                classNamePrefix="bmm-select"
                                                styles={getUniversitySelectStyles(!!formErrors.workplace)}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <Form.Control
                                        type="text"
                                        name="workplace"
                                        value={formData.workplace}
                                        onChange={onChange}
                                        placeholder={selectedRole === 'Школьник' ? 'Например: Лицей №1535, Гимназия №1' : 'Например: Яндекс / Разработчик'}
                                        isInvalid={!!formErrors.workplace}
                                    />
                                )}
                                {formErrors.workplace && (
                                    <div className="invalid-feedback d-block">{formErrors.workplace}</div>
                                )}
                            </Form.Group>
                        )}

                        <Form.Group controlId="formBirthday" className="mb-3">
                            <Form.Label className="required">Дата рождения</Form.Label>
                            <Form.Control
                                type="date"
                                name="birth_date"
                                value={formData.birth_date}
                                onChange={onChange}
                                isInvalid={!!formErrors.birth_date}
                            />
                            {formErrors.birth_date && (
                                <div className="invalid-feedback d-block">
                                    {formErrors.birth_date}
                                </div>
                            )}
                        </Form.Group>

                        <Form.Group controlId="formAddress" className="mb-3">
                            <Form.Label className="required">Город проживания</Form.Label>
                            <div className="form-check mb-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="isCustomCityCheckbox"
                                    checked={isCustomCity}
                                    onChange={(e) => {
                                        setIsCustomCity(e.target.checked);
                                        handleSelectChange('address', '');
                                    }}
                                />
                                <label className="form-check-label" htmlFor="isCustomCityCheckbox">
                                    Моего города нет в списке
                                </label>
                            </div>
                            {isCustomCity ? (
                                <Form.Control
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={onChange}
                                    placeholder="Введите название города"
                                    isInvalid={!!formErrors.address}
                                />
                            ) : (
                                <CitySelect
                                    value={formData.address}
                                    onChange={(value) => handleSelectChange('address', value)}
                                    placeholder="Выберите город..."
                                    classNamePrefix="bmm-select"
                                    styles={getCitySelectStyles(!!formErrors.address)}
                                />
                            )}
                            {formErrors.address && (
                                <div className="invalid-feedback d-block">
                                    {formErrors.address}
                                </div>
                            )}
                        </Form.Group>

                        <Form.Group controlId="formContact" className="mb-3">
                            <Form.Label className="required">Контакты</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="contact"
                                value={formData.contact}
                                onChange={onChange}
                                placeholder="Telegram, VK, MAX..."
                                isInvalid={!!formErrors.contact}
                            />
                            {formErrors.contact && (
                                <div className="invalid-feedback d-block">
                                    {formErrors.contact}
                                </div>
                            )}
                        </Form.Group>

                        <Form.Group controlId="formPhoneNumber" className="mb-3">
                            <Form.Label className="required">Номер телефона</Form.Label>
                            <PhoneInput
                                defaultCountry="ru"
                                inputProps={{name: "phone_number"}}
                                value={formData.phone_number}
                                onChange={onChangePhone}
                                style={{ zIndex: 1 }}
                            />
                            {formErrors.phone_number && (
                                <div className="invalid-feedback d-block">
                                    {formErrors.phone_number}
                                </div>
                            )}
                        </Form.Group>

                        <Button view="action" type="submit" disabled={submitting} className="mt-3 w-100" size="l">
                            {submitting ? 'Сохранение...' : 'Сохранить'}
                        </Button>
                    </Form>
                </div>
                <div className="col-lg-3">
                    <Form>
                        <Form.Label>Изображение профиля</Form.Label>
                        <Form.Control
                            className="hidden"
                            type="file"
                            ref={filePicker}
                            accept="image/*"
                            onChange={onChangeAvatar}
                        />
                        <div className="avatar-upload position-relative" role="button" onClick={onPick}>
                            <UserCard
                                size="l"
                                imgUrl={user?.avatar}
                                name={`${user?.last_name || ''} ${user?.first_name || ''}`}
                                initialsOnly={true}
                            />
                            <span className="avatar-upload__button">
                                <Pencil/> Изменить
                            </span>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = state => ({
    user: state.auth.user,
});

export default connect(mapStateToProps, {load_user})(UserFormUpdate);